export function determineFileSize1024(n: number): string {
    if (n === 0.0) {
        return "0 B";
    }

    const ROUND_DIGITS = 2;
    const BASE = 1024;
    const SUFFIXES = ["B", "KiB", "MiB", "GiB", "TiB"];

    let i = Math.floor(Math.log(n) / Math.log(BASE));
    if (i >= SUFFIXES.length) {
        i = SUFFIXES.length - 1;
    }
    n /= BASE ** i;
    n = Math.round(n * 10 ** ROUND_DIGITS) / 10 ** ROUND_DIGITS;

    return `${n} ${SUFFIXES[i]}`;
}
